export default "__VITE_ASSET__2887c6a4__"